import React from "react";

// --- CSS --- //
import "../../styles/certification-card.css";

// --- ASSETS --- //
import BusinessIcon from "@mui/icons-material/Business";
import PersonIcon from "@mui/icons-material/Person";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';

// Utility to determine validity status and days left
const getValidityStatus = (daysLeft) => {
    if (daysLeft < 0) return { label: `Expired`, color: "#E57373" }; // Red
    if (daysLeft <= 30) return { label: `Expires in ${daysLeft} days`, color: "#FFB74D" }; // Orange
    return { label: `Valid`, color: "#81C784" }; // Green
};

const CertificationCard = ({
    certTitle,
    certGym,
    certEmployee,
    startDate,
    endDate,
    startTime,
    endTime,
    certType,
    dateDifference,
    // onDelete,
    // onTutorial,
}) => {
    const validityStatus = getValidityStatus(dateDifference);

    return (
        <div className="cert-card-container">
            <p className="card-type">{certType}</p>
            <div className="card-text-container">
                <h4 className="card-title">{certTitle}</h4>
                <p className="card-exp-text" style={{ color: validityStatus.color }}><b>{validityStatus.label}</b></p>
            </div>
            <div className="card-data-block-container">
                <div className="block-container" id="gym-block-container">
                    <BusinessIcon className="block-icon" />
                    <p className="block-text">Certified at <b>{certGym}</b></p>
                </div>
                <div className="block-container" id="employee-block-container">
                    <PersonIcon className="block-icon" />
                    <p className="block-text">Certified by <b>{certEmployee}</b></p>
                </div>
            </div>
            <div className="time-card-container">
                {/* Left Section */}
                <div className="time-card-left">
                    <div className="time-icon">
                        <CalendarMonthIcon style={{ fontSize: 20, color: "white" }} />
                    </div>
                    <div className="time-text">
                        <p className="time-label">{startDate}</p>
                        <p className="time-value">{startTime}</p>
                    </div>
                </div>

                {/* Right Section */}
                <div className="time-card-right">
                    <p className="time-label">{endDate}</p>
                    <p className="time-value">{endTime}</p>
                </div>
            </div>
        </div>
    );
};

export default CertificationCard;